import {ajaxRest} from './ajaxBase'

const CONTROLLER_PREFIX = 'org'

function getOrgPreference (param) {
  let p = new Promise((resolve, reject) => {
    let params
    params = {
      url: `/${CONTROLLER_PREFIX}/getPreference${param}`,
      method: 'GET',
      timeout: {client: 10 * 1000}
    }
    ajaxRest(params).then(data => {
      resolve(data)
    }).catch(error => {
      reject(error)
    })
  })
  return p
}

function setOrgPreference (param) {
  let p = new Promise((resolve, reject) => {
    let params
    params = {
      url: `/${CONTROLLER_PREFIX}/setPreference`,
      method: 'post',
      data: param,
      timeout: {client: 10 * 1000}
    }
    ajaxRest(params).then(data => {
      resolve(data)
    }).catch(error => {
      reject(error)
    })
  })
  return p
}

export default { getOrgPreference, setOrgPreference }



// WEBPACK FOOTER //
// ./src/api/orgSettingAPI.js